import { bluedotPrimaryColors } from '@/shared/lib/mantine/mantine.colors'

export const defaultTheme = {
  backgroundColorOne: bluedotPrimaryColors[1],
  backgroundColorTwo: bluedotPrimaryColors[3],
}
